import { render, staticRenderFns } from "./serviceRateCell.vue?vue&type=template&id=605240bf&scoped=true"
import script from "./serviceRateCell.vue?vue&type=script&lang=js"
export * from "./serviceRateCell.vue?vue&type=script&lang=js"
import style0 from "./serviceRateCell.vue?vue&type=style&index=0&id=605240bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605240bf",
  null
  
)

export default component.exports